import { render, staticRenderFns } from "./h-limit-transaction-setting.vue?vue&type=template&id=c64857a8&"
import script from "./h-limit-transaction-setting.vue?vue&type=script&lang=js&"
export * from "./h-limit-transaction-setting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports